export default __webpack_public_path__ + "img/hamburger.af361244.svg";